// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"style_thumbnail__2CIlT"};